import styled from "styled-components";

export const ContainerVehicleSearch = styled.div`
	grid-column: 1 / -1;
	margin-bottom: 15px;

	.MuiInputBase-root {
		border: none;
	}
`;
